

import indigo from '@material-ui/core/colors/indigo';
import pink from '@material-ui/core/colors/pink';
import red from '@material-ui/core/colors/red';
import { createMuiTheme } from '@material-ui/core/styles';
import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet';
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';
import AssignmentInd from '@material-ui/icons/AssignmentInd';
import CardTravelIcon from '@material-ui/icons/CardTravel';
import FlightLandIcon from '@material-ui/icons/FlightLand';
import FlightTakeoffIcon from '@material-ui/icons/FlightTakeoff';
import HourglassEmptyIcon from '@material-ui/icons/HourglassEmpty';
import PanToolIcon from '@material-ui/icons/PanTool';
import ReceiptIcon from '@material-ui/icons/Receipt';
import RowingIcon from '@material-ui/icons/Rowing';
import SearchIcon from '@material-ui/icons/Search';
import SyncAltIcon from '@material-ui/icons/SyncAlt';
import polyglotI18nProvider from 'ra-i18n-polyglot';
import englishMessages from 'ra-language-english';
import frenchMessages from 'ra-language-french';
import React, { Component } from 'react';
import { Admin, fetchUtils, Layout, Resource, Sidebar } from 'react-admin';
//import jsonServerProvider from 'ra-data-json-server';
import AuthProvider from './authProvider.js';
import ListEncaissement from './caisse/ListEncaissement.js';
import CreateCampagne from './campagne/CreateCampagne';
import EditCampagne from './campagne/EditCampagne';
import ListCampagne from './campagne/ListCampagne';
import ShowCampagne from './campagne/ShowCampagne.js';
import ListChargement from './chargement/ListChargement';
import ListColis from './colis/ListColis.js';
import customRoutes from './customRoutes/customRoutes';
import GuetsiDataProvider from './dataProvider/GuetsidataProvider';
import CreateDepense from './depense/CreateDepense.js';
import ListDepense from './depense/ListDepense.js';
import ShowDepense from './depense/ShowDepense';
//import ListEtiquette from './campagne/ListEtiquette_'
import CreateOrder from './order/CreateOrder';
import EditOrder from './order/EditOrder';
import ListAllOrders from './order/ListAllOrders';
import ListOrder from './order/ListOrder';
import InvoiceShow from './invoices/InvoiceShow';
import ListLivraison from './livraison/ListLivraison';
import MyAppBar from './MyAppBar.js';
import ListReception from './reception/ListReception';
import ListRecherche from './recherche/Recherche';
import { has_role } from './references';
import MyLoginPage from './user/MyLoginPage';
import CreateVersement from './versement/CreateVersement';
import ListVersement from './versement/ListVersement';
import ShowVersement from './versement/ShowVersement';
import EditVersement from './versement/EditVersement';
import ListSolde from './compta/ListSolde';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import ListJustif from './compta/ListJustif';
import TimelineIcon from '@material-ui/icons/Timeline';
import DriveEtaIcon from '@material-ui/icons/DriveEta';
import FindInPageIcon from '@material-ui/icons/FindInPage';
import CreateVehiculeOrder from './order/CreateVehiculeOrder'

const theme = createMuiTheme({
    palette: {
        primary: indigo,
        secondary: pink,
        error: red,
        contrastThreshold: 3,
        tonalOffset: 0.2
    },
    typography: {
        // Use the system font instead of the default Roboto font.
        fontFamily: [
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Arial',
            'sans-serif',
        ].join(','),
    },
    overrides: {
        MuiButton: { // override the styles of all instances of this component
            root: { // Name of the rule
                color: 'white', // Some CSS
            },
        },
    },

    sidebar: {
        width: 170, // The default value is 240
        closedWidth: 45, // The default value is 55
        prmary: indigo
    }

});




//const i18nProvider = locale => messages[locale];
//const i18nProvider = polyglotI18nProvider(locale => messages[locale], 'fr', { allowMissing: true });
/*

const messages = {
    fr: frenchMessages
}


const i18nProvider = {
    translate: key => lodashGet(messages, key),
    changeLocale: newLocale => {
        messages = (newLocale === 'fr') ? frenchMessages : englishMessages;
        locale = newLocale;
        return Promise.resolve();
    },
    getLocale: () => locale
};


const i18nProvider = polyglotI18nProvider(locale => 
    locale === 'fr' ? frenchMessages : englishMessages,
    'fr' // Default locale
);
const i18nProvider = polyglotI18nProvider(() => frenchMessages, 'fr');
*/


const i18nProvider = polyglotI18nProvider(
    locale => (locale === 'fr' ? frenchMessages : englishMessages),
    'fr', // Default locale
    { allowMissing: true }
);




const MySidebar = props => <Sidebar {...props} />;
const MyLayout = props => <Layout
    {...props}
    sidebar={MySidebar}
    appBar={MyAppBar}
/>;

//const MyLoginPage = () => <Login backgroundImage="images/tldi_bg.svg" />;

const httpClient = (url, options = {}) => {
    if (!options.headers) {
        options.headers = new Headers({ 'Content-Type': 'application/json' });
    }

    const token = localStorage.getItem('token');
    options.headers.set('Authorization', `Bearer ${token}`);

    //options.headers.set('Access-Control-Expose-Headers', 'x-total-count');
    return fetchUtils.fetchJson(url, options);
}


class App extends Component {
    state = { dataProvider: null };

    

    async componentDidMount() {
        const dataProvider = await GuetsiDataProvider(process.env.REACT_APP_URL, httpClient);
        this.setState({ dataProvider });
    }

    render() {
        const { dataProvider } = this.state;
        //const {basePath,resource} = this.rest;

        if (!dataProvider) {
            return (
                <div className="loader-container">
                    <div className="loader">Chargement...</div>
                </div>
            );
        }

        return (
            <Admin title="TLDI LOGISTIQUE SERVICES"
                i18nProvider={i18nProvider}
                dataProvider={dataProvider}
                authProvider={AuthProvider}
                loginPage={MyLoginPage}
                layout={MyLayout}
                theme={theme}
                customRoutes={customRoutes}
            >

            {permissions =>
                [
                    
                    <Resource name={ has_role(permissions,'ROLE_AG_EXP_AERIEN_FR')  || has_role(permissions,'ROLE_AG_EXP_AERIEN_GUI')  ? 'etiq/livraison' :'fret'}
                    list={ has_role(permissions,'ROLE_AG_EXP_AERIEN_FR')  || has_role(permissions,'ROLE_AG_EXP_AERIEN_GUI')   ? ListLivraison :ListAllOrders}
                    show={InvoiceShow} 
                    icon={SearchIcon}
                    options={{ label: 'Livraison' }}
                    />,
                    
                    <Resource name={has_role(permissions,'ROLE_AG_EXP_MARITIME_FR')  || has_role(permissions,'ROLE_AG_EXP_AERIEN_GUI')  ? 'aerien' : 'fret'}
                        list={  has_role(permissions,'ROLE_AG_EXP_MARITIME_FR')  || has_role(permissions,'ROLE_AG_EXP_AERIEN_GUI')  ? ListOrder :ListAllOrders}
                        show={ has_role(permissions,'ROLE_MANAGER') || has_role(permissions,'ROLE_AG_EXP_MARITIME_FR')  || has_role(permissions,'ROLE_AG_EXP_AERIEN_GUI')  ? InvoiceShow :null} 
                        create={ has_role(permissions,'ROLE_AG_EXP_MARITIME_FR') ? CreateOrder : null}
                        edit={ has_role(permissions,'ROLE_MANAGER') || has_role(permissions,'ROLE_AG_EXP_MARITIME_FR')  ? EditOrder : null}
                        icon={FlightTakeoffIcon}
                        options={{ label: 'Fret aérien' }}
                    />,                    
                
                    <Resource name={  has_role(permissions,'ROLE_MANAGER') || has_role(permissions,'ROLE_AG_EXP_MARITIME_FR')  || has_role(permissions,'ROLE_AG_EXP_AERIEN_GUI')  ? 'maritime' :null}
                        list={  has_role(permissions,'ROLE_AG_EXP_MARITIME_FR')  || has_role(permissions,'ROLE_AG_EXP_AERIEN_GUI')  ? ListOrder :null}
                        show={ has_role(permissions,'ROLE_MANAGER') || has_role(permissions,'ROLE_AG_EXP_MARITIME_FR')  || has_role(permissions,'ROLE_AG_EXP_AERIEN_GUI')  ? InvoiceShow :null} 
                        create={ has_role(permissions,'ROLE_AG_EXP_MARITIME_FR') ? CreateOrder : null}
                        edit={  has_role(permissions,'ROLE_MANAGER') || has_role(permissions,'ROLE_AG_EXP_MARITIME_FR')  ? EditOrder : null}
                        icon={RowingIcon}
                        options={{ label: 'Fret maritime' }}
                    />,
                    <Resource name={  has_role(permissions,'ROLE_MANAGER') || has_role(permissions,'ROLE_AG_EXP_MARITIME_FR')  || has_role(permissions,'ROLE_AG_EXP_AERIEN_GUI')   ? 'aerien_de_cnkry' :null}
                        list={   has_role(permissions,'ROLE_AG_EXP_MARITIME_FR')  || has_role(permissions,'ROLE_AG_EXP_AERIEN_GUI')  ? ListOrder :null}
                        show={  has_role(permissions,'ROLE_MANAGER') || has_role(permissions,'ROLE_AG_EXP_MARITIME_FR')  || has_role(permissions,'ROLE_AG_EXP_AERIEN_GUI')  ? InvoiceShow :null} 
                        create={ has_role(permissions,'ROLE_AG_EXP_AERIEN_GUI') ? CreateOrder : null}
                        edit={  has_role(permissions,'ROLE_MANAGER') || has_role(permissions,'ROLE_AG_EXP_AERIEN_GUI')  ? EditOrder : null}

                        icon={FlightLandIcon}
                        options={{ label: 'Fret Conakry' }}
                    />,
                    
                    <Resource name={  has_role(permissions,'ROLE_MANAGER') || has_role(permissions,'ROLE_AG_EXP_MARITIME_FR')  || has_role(permissions,'ROLE_AG_EXP_AERIEN_GUI')  ? 'vehicule' :null}
                        list={  has_role(permissions,'ROLE_AG_EXP_MARITIME_FR')  || has_role(permissions,'ROLE_AG_EXP_AERIEN_GUI')  ? ListOrder :null}
                        show={ has_role(permissions,'ROLE_MANAGER') || has_role(permissions,'ROLE_AG_EXP_MARITIME_FR')  || has_role(permissions,'ROLE_AG_EXP_AERIEN_GUI')  ? InvoiceShow :null} 
                        create={ has_role(permissions,'ROLE_AG_EXP_MARITIME_FR') ? CreateVehiculeOrder : null}
                        edit={  has_role(permissions,'ROLE_MANAGER') || has_role(permissions,'ROLE_AG_EXP_MARITIME_FR')  ? EditOrder : null}
                        icon={DriveEtaIcon}
                        options={{ label: 'Véhicule' }}
                    />,
                    <Resource name={  has_role(permissions,'ROLE_MANAGER')   ? 'fret' :null}
                        list={   has_role(permissions,'ROLE_MANAGER')  ? ListAllOrders :null}
                        show={  has_role(permissions,'ROLE_MANAGER')  ? InvoiceShow :null} 
                        edit={  has_role(permissions,'ROLE_MANAGER')  ? EditOrder : null}

                        icon={FlightLandIcon}
                        options={{ label: 'Fret' }}
                    />,
                    <Resource name={ has_role(permissions,'ROLE_AG_EXP_AERIEN_FR')  || has_role(permissions,'ROLE_AG_EXP_AERIEN_GUI') || has_role(permissions,'ROLE_MANAGER')  ? 'etiq/etiqByStatusOrCode' :null}
                        list={ has_role(permissions,'ROLE_AG_EXP_AERIEN_FR')  || has_role(permissions,'ROLE_AG_EXP_AERIEN_GUI') || has_role(permissions,'ROLE_MANAGER') ? ListChargement :null}
                        show={ has_role(permissions,'ROLE_AG_EXP_AERIEN_FR')  || has_role(permissions,'ROLE_AG_EXP_AERIEN_GUI') || has_role(permissions,'ROLE_MANAGER')  ? InvoiceShow :null} 
                        icon={HourglassEmptyIcon}
                        options={{ label: 'Chargement' }}
                    />,
                    <Resource name={ has_role(permissions,'ROLE_AG_EXP_AERIEN_FR')  || has_role(permissions,'ROLE_AG_EXP_AERIEN_GUI') || has_role(permissions,'ROLE_MANAGER')  ? 'etiq/etiqReceptionColis' :null}
                        list={ has_role(permissions,'ROLE_AG_EXP_AERIEN_FR')  || has_role(permissions,'ROLE_AG_EXP_AERIEN_GUI') || has_role(permissions,'ROLE_MANAGER') ? ListReception :null}
                        show={ has_role(permissions,'ROLE_AG_EXP_AERIEN_FR')  || has_role(permissions,'ROLE_AG_EXP_AERIEN_GUI') || has_role(permissions,'ROLE_MANAGER')  ? InvoiceShow :null} 
                        icon={SyncAltIcon}
                        options={{ label: 'Reception' }}
                    />,
                    <Resource name={ has_role(permissions,'ROLE_MANAGER') ? 'etiq/livraison' :null}
                    list={has_role(permissions,'ROLE_MANAGER')  ? ListLivraison :null}
                    show={ has_role(permissions,'ROLE_MANAGER')  ? InvoiceShow :null} 
                    icon={SearchIcon}
                    options={{ label: 'Livraison' }}
                    />,
                    <Resource name={ has_role(permissions,'ROLE_AG_EXP_AERIEN_FR')  || has_role(permissions,'ROLE_AG_EXP_AERIEN_GUI') || has_role(permissions,'ROLE_MANAGER')  ? 'etiq/recherche' :null}
                        list={ has_role(permissions,'ROLE_AG_EXP_AERIEN_FR')  || has_role(permissions,'ROLE_AG_EXP_AERIEN_GUI') || has_role(permissions,'ROLE_MANAGER')  ? ListRecherche :null}
                        show={ has_role(permissions,'ROLE_AG_EXP_AERIEN_FR')  || has_role(permissions,'ROLE_AG_EXP_AERIEN_GUI') || has_role(permissions,'ROLE_MANAGER')  ? InvoiceShow :null} 
                        icon={FindInPageIcon}
                        options={{ label: 'Recherche' }}
                        />,
                        
                        <Resource name={ has_role(permissions,'ROLE_MANAGER')  ? 'etiq/colisCampChanged' :null}
                        list={has_role(permissions,'ROLE_MANAGER')  ? ListColis :null}
                        show={has_role(permissions,'ROLE_MANAGER')  ? InvoiceShow :null} 
                        icon={CardTravelIcon}
                        options={{ label: 'Colis' }}
                        />,
                    <Resource name={ has_role(permissions,'ROLE_AG_EXP_AERIEN_FR')  || has_role(permissions,'ROLE_AG_EXP_AERIEN_GUI') || has_role(permissions,'ROLE_MANAGER')  ? 'caisse' :null}
                        list={ has_role(permissions,'ROLE_AG_EXP_AERIEN_FR')  || has_role(permissions,'ROLE_AG_EXP_AERIEN_GUI') || has_role(permissions,'ROLE_MANAGER')  ? ListEncaissement :null}
                        show={ has_role(permissions,'ROLE_AG_EXP_AERIEN_FR')  || has_role(permissions,'ROLE_AG_EXP_AERIEN_GUI') || has_role(permissions,'ROLE_MANAGER')  ? InvoiceShow :null} 
                        icon={AccountBalanceWalletIcon}
                        options={{ label: 'Encaissement' }}
                    />,
                    <Resource name={ has_role(permissions,'ROLE_AG_EXP_AERIEN_FR')  || has_role(permissions,'ROLE_AG_EXP_AERIEN_GUI') || has_role(permissions,'ROLE_MANAGER')  ? 'vst' :null}
                        list={ has_role(permissions,'ROLE_AG_EXP_AERIEN_FR')  || has_role(permissions,'ROLE_AG_EXP_AERIEN_GUI') || has_role(permissions,'ROLE_MANAGER')  ? ListVersement :null}
                        create={ has_role(permissions,'ROLE_AG_EXP_AERIEN_FR')  || has_role(permissions,'ROLE_AG_EXP_AERIEN_GUI') || has_role(permissions,'ROLE_MANAGER')  ? CreateVersement :null} 
                        show={ has_role(permissions,'ROLE_AG_EXP_AERIEN_FR')  || has_role(permissions,'ROLE_AG_EXP_AERIEN_GUI') || has_role(permissions,'ROLE_MANAGER')  ? ShowVersement :null} 
                        edit={ has_role(permissions,'ROLE_AG_EXP_AERIEN_FR')  || has_role(permissions,'ROLE_AG_EXP_AERIEN_GUI') || has_role(permissions,'ROLE_MANAGER')  ? EditVersement :null} 
                        icon={ReceiptIcon}
                        options={{ label: 'Versement' }}
                    />,
                            
                    <Resource name={ has_role(permissions,'ROLE_AG_EXP_AERIEN_FR')  || has_role(permissions,'ROLE_AG_EXP_AERIEN_GUI') || has_role(permissions,'ROLE_MANAGER')  ? 'dep' :null}
                        list={ has_role(permissions,'ROLE_AG_EXP_AERIEN_FR')  || has_role(permissions,'ROLE_AG_EXP_AERIEN_GUI') || has_role(permissions,'ROLE_MANAGER')  ? ListDepense :null}
                        create={ has_role(permissions,'ROLE_AG_EXP_AERIEN_FR')  || has_role(permissions,'ROLE_AG_EXP_AERIEN_GUI') || has_role(permissions,'ROLE_MANAGER')  ? CreateDepense:null} 
                        show={ has_role(permissions,'ROLE_AG_EXP_AERIEN_FR')  || has_role(permissions,'ROLE_AG_EXP_AERIEN_GUI') || has_role(permissions,'ROLE_MANAGER')  ? ShowDepense :null} 
                        icon={AddShoppingCartIcon}
                        options={{ label: 'Dépense' }}
                    />,
                                       
                    <Resource name={has_role(permissions,'ROLE_MANAGER') || has_role(permissions,'ROLE_AG_EXP_AERIEN_FR')  || has_role(permissions,'ROLE_AG_EXP_AERIEN_GUI') ? 'camp' : null}
                        list={ListCampagne}
                        create={has_role(permissions,'ROLE_MANAGER')  ? CreateCampagne: null}
                        edit={has_role(permissions,'ROLE_MANAGER') || has_role(permissions,'ROLE_AG_EXP_AERIEN_FR')  || has_role(permissions,'ROLE_AG_EXP_AERIEN_GUI') ? EditCampagne : null}
                        show={ShowCampagne}
                        icon={AssignmentInd}
                        options={{label : 'Campagne' }}
                    />,
                    <Resource name='compta/solde'
                        list={ has_role(permissions,'ROLE_AG_EXP_AERIEN_FR')  || has_role(permissions,'ROLE_AG_EXP_AERIEN_GUI') || has_role(permissions,'ROLE_MANAGER')  ? ListSolde :null}
                        icon={AccountBalanceIcon}
                        options={{ label: 'Solde' }}
                    />,
                    <Resource name='compta/justif'
                        list={ has_role(permissions,'ROLE_AG_EXP_AERIEN_FR')  || has_role(permissions,'ROLE_AG_EXP_AERIEN_GUI') || has_role(permissions,'ROLE_MANAGER')  ? ListJustif :null}
                        icon={TimelineIcon}
                        options={{ label: 'Justificatif' }}
                    />
                ]}

            </Admin>
        );
    }
}

export default App;
